'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _lodash = require('lodash');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _input = require('../input');
var _formField = require('../form-field');
var _formField2 = _interopRequireDefault(_formField);
var _constants = require('../../constants');
var _controlFields = require('../../hocs/control-fields');
var _controlFields2 = _interopRequireDefault(_controlFields);
var _result = require('./result');
var _result2 = _interopRequireDefault(_result);
var _readOnly = require('../read-only');
var _readOnly2 = _interopRequireDefault(_readOnly);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Reset = (0, _glamorous2.default)('a')(function (_ref) {
  var theme = _ref.theme;
  return {
    paddingTop: theme.space_xs,
    display: 'block'
  };
});
var SearchInput = function (_Component) {
  _inherits(SearchInput, _Component);
  function SearchInput() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck(this, SearchInput);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SearchInput.__proto__ || Object.getPrototypeOf(SearchInput)).call.apply(_ref2, [this].concat(args))), _this), _this.handleControl = function (value) {
      _this.props.control(_defineProperty({}, _this.props.name + 'Text', value));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(SearchInput, [{
    key: 'createResults',
    value: function createResults() {
      var _props = this.props,
        results = _props.results,
        allowFreeType = _props.allowFreeType,
        setResult = _props.setResult;
      return results.length ? results.map(function (result) {
        return _react2.default.createElement(_result2.default, {
          key: result.value,
          onClick: setResult,
          text: result.text,
          value: result.value
        });
      }) : _react2.default.createElement(_result2.default, {
        text: allowFreeType ? this.value() : 'No results found',
        onClick: allowFreeType ? setResult : undefined,
        value: allowFreeType ? this.value() : undefined
      });
    }
  }, {
    key: 'isValidating',
    value: function isValidating() {
      return ~this.props.validating.indexOf(this.props.name);
    }
  }, {
    key: 'error',
    value: function error() {
      return this.props.errors[this.props.name];
    }
  }, {
    key: 'value',
    value: function value() {
      return this.props.values[this.props.name + 'Text'] || '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
        label = _props2.label,
        name = _props2.name,
        results = _props2.results,
        loading = _props2.loading,
        helpText = _props2.helpText,
        disabled = _props2.disabled,
        readOnly = _props2.readOnly,
        rest = _objectWithoutProperties(_props2, ['label', 'name', 'results', 'loading', 'helpText', 'disabled', 'readOnly']);
      var error = this.error();
      return _react2.default.createElement('div', null, _react2.default.createElement(_formField2.default, {
        label: label,
        error: error,
        name: name,
        helpText: helpText,
        disabled: disabled
      }, readOnly ? _react2.default.createElement(_readOnly2.default, null, this.value(), this.props.reset && _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(Reset, {
        onClick: this.props.reset
      }, this.props.resetText))) : _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_input.Input, Object.assign({}, (0, _lodash.omit)(rest, [].concat(_toConsumableArray(_constants.omitProps), ['validating', 'values', 'setValues', 'product', 'errors'])), {
        value: this.value(),
        name: name,
        onChange: this.handleControl,
        validating: this.isValidating() || loading,
        css: typeof results !== 'undefined' ? {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        } : undefined,
        valid: typeof error !== 'undefined' ? !error.length : undefined,
        autoComplete: 'off'
      })), typeof results !== 'undefined' && this.createResults())));
    }
  }]);
  return SearchInput;
}(_react.Component);
SearchInput.propTypes = Object.assign({}, _constants.fieldPropTypes, {
  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    text: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired
  })),
  setResult: _propTypes.func,
  reset: _propTypes.func,
  resetText: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  loading: _propTypes.bool,
  readOnly: _propTypes.bool,
  values: _propTypes.object,
  validating: (0, _propTypes.arrayOf)(_propTypes.string),
  errors: (0, _propTypes.objectOf)(_propTypes.string),
  allowFreeType: _propTypes.bool
});
SearchInput.defaultProps = Object.assign({}, _constants.defaultFieldPropTypes, {
  results: undefined,
  reset: undefined,
  resetText: 'Reset',
  setResult: undefined,
  value: '',
  loading: false,
  readOnly: undefined,
  validating: [],
  allowFreeType: false
});
exports.default = (0, _controlFields2.default)(SearchInput);